// Composant responsive qui bascule automatiquement entre desktop et mobile pour l'interface Admin
import React from "react";
import { useExplanationResponsive } from "../../../hooks/useResponsive";
import AdminExplanations from "./index";
import MobileAdminExplanations from "./MobileAdminExplanations";

const ResponsiveAdminExplanations: React.FC = () => {
  const { shouldUseMobileLayout } = useExplanationResponsive();

  // Basculer automatiquement entre les versions desktop et mobile
  if (shouldUseMobileLayout) {
    return <MobileAdminExplanations />;
  }

  return <AdminExplanations />;
};

export default ResponsiveAdminExplanations;
